import {useLingui} from "@lingui/react";
import {Trans} from "@lingui/react/macro";
import {useState} from "react";
import {useNavigate} from "react-router";
import * as v from "valibot";
import {createNewGroup} from "../../models/group-model-helpers";
import type {UserRepo} from "../../models/UserRepo";
import {css} from "../../ui/Box";
import {useKeypress} from "../../utils/use-keypress";
import {CheckboxField, TextAreaField, TextField} from "../form/fields";
import {useForm} from "../form/Form";

const createGroupFormSchema = v.object({
  groupName: v.pipe(v.string(), v.nonEmpty()),
  withTemplate: v.boolean(),
  secretInput: v.string(),
});

const AddGroupForm = ({userRepo}: {userRepo: UserRepo}) => {
  const navigate = useNavigate();
  const [showSecretInput, setShowSecretInput] = useState(false);
  useKeypress({
    code: "KeyI",
    withMeta: true,
    onKey: () => {
      setShowSecretInput((v) => !v);
    },
  });
  const {i18n} = useLingui();
  const {field, Form} = useForm({
    initial: {groupName: "", withTemplate: true, secretInput: ""},
    schema: createGroupFormSchema,
    onSubmit: async ({groupName, withTemplate, secretInput}) =>
      createNewGroup({
        userRepo,
        name: groupName,
        i18n,
        withTemplate,
        importString: secretInput || null,
      }).then((group) => {
        navigate(`/g/${group.shortId}`);
      }),
  });
  return (
    <Form
      buttonLabel={<Trans>Create New Group</Trans>}
      className={css({sp: "16", display: "flex", flexDir: "column"})}
    >
      <TextField field={field("groupName")} label={<Trans>Name</Trans>} />
      <CheckboxField field={field("withTemplate")} label={<Trans>With Template</Trans>} />
      {showSecretInput && (
        <TextAreaField field={field("secretInput")} label={<Trans>Secret Input</Trans>} />
      )}
    </Form>
  );
};

export default AddGroupForm;
